import {
  mapColumnKeyToApiSortField,
  OrderByItem,
  SortField,
} from '@/features/invoice_reports/types';
import { InvoiceReportOrderByDirection } from 'ap-openapi';

// Helper function to build order_by array - extracted for better performance
export const buildOrderByArray = (
  sortOrders: { order: 'ascend' | 'descend'; columnKey: string }[] | undefined
): OrderByItem[] | undefined => {
  if (!sortOrders || sortOrders.length === 0) return undefined;
  return sortOrders.map((sortState) => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const field = mapColumnKeyToApiSortField(sortState.columnKey as SortField);
    const direction: InvoiceReportOrderByDirection =
      sortState.order === 'ascend' ? 'asc' : 'desc';
    return { field, direction };
  });
};
